import api from './api';

export const listUsers = async () => {
  const res = await api.get('/users');
  return res.data;
};

export const getAvailableUserProducts = async () => {
  const res = await api.get('/users/available-products');
  return Array.isArray(res.data?.products) ? res.data.products : [];
};

export const getUser = async (id) => {
  const res = await api.get(`/users/${id}`);
  return res.data;
};

export const createUser = async (payload) => {
  const res = await api.post('/users', payload);
  return res.data;
};

export const updateUser = async (id, payload) => {
  const res = await api.put(`/users/${id}`, payload);
  return res.data;
};

export const deleteUser = async (id) => {
  await api.delete(`/users/${id}`);
};
